import Component from '../abstracts/Component';
import ChatUtils from '../utils/ChatUtils';

export default class LiveChatTriggerComponent extends Component {

  get SELECTORS() {
    return {
      chatTrigger: '.cta-editorial',
      salesforceTrigger: 'button.helpButtonEnabled, button.helpButton',
      coremediaTrigger: '.bs-ew-toggle'
    }
  }

  get CLASSES() {
    return {
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.$myComponents = (this.$component !== null) ? this.$component : document.querySelectorAll('[data-js-component=LiveChatTriggerComponent]');
    const ctx = this;
    $(document).ready(function() {
      ctx.$myComponents.forEach(function(component) {
        const liveChatType = component.dataset.liveChatType;
        const chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
        if (liveChatType && liveChatType !== '' && chatEnabled === 'true') {
          $(component).removeAttr('data-link');
          $(component).find('[data-link]').removeAttr('data-link');
          $(component).attr('data-link-disabled','disabled');
          $(component.querySelector(ctx.SELECTORS.chatTrigger)).removeAttr('href');
        }
      });
    });
  }

  bindEvents() {
    const ctx = this;
    $(document).ready(function() {
      ctx.$myComponents.forEach(function(component) {
        component.querySelector(ctx.SELECTORS.chatTrigger).addEventListener('click', function(e) {
          const liveChatType = component.dataset.liveChatType;
          const chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
          if (liveChatType && liveChatType !== '' && chatEnabled === 'true') {
            const fallbackChatSelector = component.dataset.fallbackChatSelector;
            const isSFSelector = liveChatType === "salesforce";
            const isCoremediaSelector = liveChatType === "coremedia";

            let chatSelector = null;
            if (isSFSelector) {
              chatSelector = document.querySelectorAll(ctx.SELECTORS.salesforceTrigger);
            } else if (isCoremediaSelector) {
              chatSelector = document.querySelector(ctx.SELECTORS.coremediaTrigger);
            }

            // Fallback selector
            if (chatSelector == null && fallbackChatSelector !== null) {
              chatSelector = document.querySelectorAll(fallbackChatSelector);
            }

            if (chatSelector !== null) {
              if (chatSelector instanceof NodeList) {
                chatSelector.forEach(function(element) {
                  element.click();
                });
              } else {
                chatSelector.click();
              }
            }
          }
        });
      });
    });
  }

  render() {
    this.log('Rendering...');
    super.render();
    this.bindEvents();
  }

}
